<template>
    <WarningPassword v-if="errorPassword"/>
    <Title :title="title"/>
    <div class="container-form">
        <form class="user-create-form" ref="createUserForm">
            <legend>Seleccione el usuario para el cual desea modificar la contraseña</legend>
            <div style="margin-top: 3rem; margin-bottom: 1rem;">
                <label>Correo</label>
                 <select name='userId' id='userId' v-model='userId' ref="selected">
                    <option
                        value="" disabled>
                        {{defaultValue}}
                    </option>
                    <option
                        v-for="user in userList"
                        :key="user.id"
                        :value="user.id">
                        {{user.email}}
                    </option>
                 </select>
            </div>
            <div v-if="userId !== ''">
                <p>EL USUARIO SELECCIONADO ES:</p>
                <div class="user-data-container">
                    <div class="input-container">
                        <label>Nombre</label>
                        <input v-model="selectedUser.name" type="text" disabled/>
                    </div>
                    <div class="input-container">
                        <label>Apellido</label>
                        <input v-model="selectedUser.lastname" type="text" disabled/>
                    </div>
                </div>
                <div class="user-data-container">
                    <div class="input-container">
                        <label>Contraseña</label>
                        <input type="password" v-model="newPassword" @input="Change_save_buttom(isMatchPassword, isValidPassword)"/>
                        <p class="text-password" v-if="!isValidPassword">La contraseña debe tener al menos 8 caracteres, 1 número y 1 caracter especial.</p>
                    </div>
                    <div class="input-container">
                        <label>Confirme contraseña</label>
                        <input type="password" v-model="confirmedPassword" @input="Change_save_buttom(isMatchPassword, isValidPassword)"/>
                        <p class="text-password" v-if="!isMatchPassword">Las contraseñas no coinciden</p>
                    </div>
                </div>
                <button class="button-save"
                    @click.prevent="SavePassword()"
                    :disabled='!seeButton'
                    :class="(seeButton) ? '' : 'button-send'">Modificar contraseña</button>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Title from '../../../components/ViewsTitle/ViewsTitle.vue'
import WarningPassword from '../../Warning/WarningPassword.vue';
import router from '../../../router';

export default {
    name: 'EditUserPasswordForm',
    data(){
        return {
            title: 'EDITAR USUARIO - Modificación de contraseña',
            defaultValue: 'Seleccione el correo',
            userId: '',
            userAction: 'Edit',
            newPassword: '',
            confirmedPassword: ''
        }
    },
    created() {
        this.getUsers()
    },
    components: {
        Title,
        WarningPassword
    },
    computed: {
        ...mapState(['userList', 'errorPassword', 'seeButton']),
        selectedUser() {
            return this.userList[this.userId] || {};
        },
        isValidPassword() {
            const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
            return passwordRegex.test(this.newPassword);
        },
        isMatchPassword(){
            return this.newPassword === this.confirmedPassword
        }
    },
    methods: {
        ...mapActions(['getUsers', 'Change_save_buttom', 'updatePassword']),
        async SavePassword(){
            try {
                await this.updatePassword({id: this.userId, password: this.newPassword})
                if(!this.errorPassword){
                    router.push('/')
                    this.$store.commit('change_user_action', this.userAction)
                }
                this.userId = ''
            } catch (error) {
                console.log(error)
            }
        }
    },
}
</script>
<style scoped>
.container-form {
    font-family: "Ancizar-regular", Helvetica, Arial;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.user-create-form {
    width: 35rem;
    box-sizing: border-box;
    border: 0.15rem solid rgb(100, 120, 20);
    border-radius: .5rem;
    margin-left: 5rem;
}
.user-data-container{
    display: flex;
}
.input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1;
}
legend {
    background-color: rgb(100, 120, 20);
    color:white;
    font-size: 1.2rem;
    padding: .3rem .2rem .3rem 2rem;
    line-height: 1.2;
}
label{
    font-size: 1rem;
    padding: .5rem 0rem 0rem 2rem;
}
p {
    font-size: 1.1rem;
    margin: 1rem 0rem 0rem 2rem;
    color:rgb(91, 109, 18);
    font-weight: bold;
}
input, select {
    margin: .2rem 0rem .5rem 2rem;
    height: 2rem;
    width: 14rem;
    border: 1px solid rgba(55, 55, 55, 0.7);
    border-radius: .5rem;
    padding-left: .5rem ;
}
select {
    margin: .2rem 0rem 0rem 1rem;
}
.button-save {
    width: 12rem;
    color: white;
    height: 2.5em;
    background-color: rgb(100, 120, 20);
    border-radius: .3rem;
    font-size: 1.1rem;
    margin: 1rem 0rem .8rem 2rem;
}
.button-send{
    width: 12rem;
    color: white;
    height: 2.5em;
    margin: .3rem 0rem .8rem 2rem;
    border: none;
    background-color: rgba(100, 120, 20, 0.658);
}
.text-password {
    margin: .2rem 0rem .5rem 2rem;
    width: 15rem;
    line-height: 1.2;
    color: rgb(91, 109, 18);
    font-weight: bold;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: .8rem;
}
</style>